import { MUTATION_NAME } from '@/static/global-variables';

const brcStore = {
    state: {
        preferredLanguage: navigator.language,
        bannerUrl: null,
        signee: null,
        detailedProducts: null,
        address: null,
        samples: null,
        license: null,
        dea: null,
        shipToLicense: null,
        shipToDea: null,
        shipToAddress: null,
        disclaimer: null,
        messageInvalidSignature: null,
        signinId: null,
        signature: null,
        loaded: false,
        uuid: null,
        route: null,
        inquiries: null,
        channelId: null,
        signatureType: null,
        hostName: null,
        consent: null,
        expireTimeoutId: null,
        requestFinished: false,
        location: null
    },
    getters: {
        bannerUrl: state => state.bannerUrl,
        signee: state => state.signee,
        detailedProducts: state => state.detailedProducts,
        address: state => state.address,
        samples: state => state.samples,
        license: state => state.license,
        dea: state => state.dea,
        shipToLicense: state => state.shipToLicense,
        shipToDea: state => state.shipToDea,
        shipToAddress: state => state.shipToAddress,
        disclaimer: state => state.disclaimer,
        messageInvalidSignature: state => state.messageInvalidSignature,
        signinId: state => state.signinId,
        preferredLanguage: state => state.preferredLanguage,
        signature: state => state.signature,
        loaded: state => state.loaded,
        uuid: state => state.uuid,
        route: state => state.route,
        inquiries: state => state.inquiries,
        channelId: state => state.channelId,
        signatureType: state => state.signatureType,
        hostName: state => state.hostName,
        consent: state => state.consent,
        expireTimeoutId: state => state.expireTimeoutId,
        requestFinished: state => state.requestFinished,
        location: state => state.location
    },
    mutations: {
        [MUTATION_NAME.SET_BANNER_URL]: (state, bannerUrl) => {
            state.bannerUrl = bannerUrl || null;
        },
        [MUTATION_NAME.SET_SIGNEE]: (state, signee) => {
            state.signee = signee || null;
        },
        [MUTATION_NAME.SET_DETAILED_PRODUCTS]: (state, detailedProducts) => {
            state.detailedProducts = detailedProducts || null;
        },
        [MUTATION_NAME.SET_ADDRESS]: (state, address) => {
            state.address = address || null;
        },
        [MUTATION_NAME.SET_SAMPLES]: (state, samples) => {
            state.samples = samples || null;
        },
        [MUTATION_NAME.SET_LICENSE]: (state, license) => {
            state.license = license || null;
        },
        [MUTATION_NAME.SET_DEA]: (state, dea) => {
            state.dea = dea || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_LICENSE]: (state, shipToLicense) => {
            state.shipToLicense = shipToLicense || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_DEA]: (state, shipToDea) => {
            state.shipToDea = shipToDea || null;
        },
        [MUTATION_NAME.SET_SHIP_TO_ADDRESS]: (state, shipToAddress) => {
            state.shipToAddress = shipToAddress || null;
        },
        [MUTATION_NAME.SET_DISCLAIMER]: (state, disclaimer) => {
            state.disclaimer = disclaimer || null;
        },
        [MUTATION_NAME.SET_MESSAGE_INVALID_SIGNATURE]: (state, messageInvalidSignature) => {
            state.messageInvalidSignature = messageInvalidSignature || null;
        },
        [MUTATION_NAME.SET_SIGNIN_ID]: (state, signinId) => {
            state.signinId = signinId || null;
        },
        [MUTATION_NAME.SET_PREFERRED_LANGUAGE]: (state, preferredLanguage) => {
            state.preferredLanguage = preferredLanguage || 'en-US';
        },
        [MUTATION_NAME.SET_SIGNATURE]: (state, signature) => {
            state.signature = signature || false;
        },
        [MUTATION_NAME.SET_LOADED]: (state, loaded) => {
            state.loaded = loaded || false;
        },
        [MUTATION_NAME.SET_UUID]: (state, uuid) => {
            state.uuid = uuid || null;
        },
        [MUTATION_NAME.SET_ROUTE]: (state, route) => {
            state.route = route || null;
        },
        [MUTATION_NAME.SET_INQUIRIES]: (state, inquiries) => {
            state.inquiries = inquiries || null;
        },
        [MUTATION_NAME.SET_CHANNEL_ID]: (state, channelId) => {
            state.channelId = channelId || null;
        },
        [MUTATION_NAME.SET_SIGNATURE_TYPE]: (state, signatureType) => {
            state.signatureType = signatureType || null;
        },
        [MUTATION_NAME.SET_HOST_NAME]: (state, hostName) => {
            state.hostName = hostName || null;
        },
        [MUTATION_NAME.SET_CONSENT]: (state, consent) => {
            state.consent = consent || null;
        },
        [MUTATION_NAME.SET_EXPIRE_TIMEOUT_ID]: (state, timeoutId) => {
            state.expireTimeoutId = timeoutId || null;
        },
        [MUTATION_NAME.SET_REQUEST_FINISHED]: (state, requestFinished) => {
            state.requestFinished = requestFinished || false;
        },
        [MUTATION_NAME.SET_LOCATION]: (state, location) => {
            state.location = location || "";
        }
    }
};

export default brcStore;
